import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { SiteHeader } from '../../components/SiteHeader';
import { HeroSection } from '../../components/HeroSection';
import { PainPointsSection } from '../../components/PainPointsSection';
import { FixReviewsSection } from '../../components/FixReviewsSection';
import { BoostSection } from '../../components/BoostSection';
import { PaigeXReviewLumenSection } from '../../components/PaigeXReviewLumenSection';
import { FeaturesSection } from '../../components/FeaturesSection';
import { IndustriesSection } from '../../components/IndustriesSection';
import { PricingSection } from '../../components/PricingSection';
import { FaqSection } from '../../components/FaqSection';
import { CtaSection } from '../../components/CtaSection';
import { FooterSection } from '../../components/FooterSection';

export function Home() {
  useDocumentTitle();

  return (
    <div className="landing">
      <SiteHeader />

      <main>
        <HeroSection />
        <PainPointsSection />
        <FixReviewsSection />
        <BoostSection />
        <PaigeXReviewLumenSection />
        <FeaturesSection />
        <IndustriesSection />
        <PricingSection />
        <FaqSection />
        <CtaSection />
      </main>

      <FooterSection />
    </div>
  );
}
